<template>
  <div id="contenedor-main-actividades-contrato">
      <actividades
      :idReferencia="idReferencia">
      </actividades>
  </div>
</template>

<script>
import Actividades from '@/views/administracion/actividades/Main.vue';

export default {
  name: 'ActividadesContratoMain',
  components: {
    Actividades,
  },
  data() {
    return {
      idReferencia: this.$route.params.idContrato,
    };
  },

};
</script>

<style>

</style>
